var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.projects.length)?_c('v-list',{attrs:{"dense":"","nav":"","color":"transparent"}},_vm._l((_vm.projects),function(project){return _c('project-list-item',{key:project.id,attrs:{"project":project,"current-id":_vm.currentId}})}),1):_c('p',{staticClass:"text-center overline grey--text"},[_vm._v("Aucun Chantier")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }